$(document).ready(function () {
  $(document.body).on('click', '.js-clickable-table-row', function(e) {
    e.preventDefault();
    window.location.href = $(this).data('url');
  });
});
